import { render } from "./AppNew.vue?vue&type=template&id=1ab58c25&scoped=true"
import script from "./AppNew.vue?vue&type=script&lang=js"
export * from "./AppNew.vue?vue&type=script&lang=js"

import "./AppNew.vue?vue&type=style&index=0&id=1ab58c25&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ab58c25"]])

export default __exports__